const $clamp = require('clamp');

export default () => {
  $('.news-know-more .know-more').each(function(){
    $clamp($(this).get(0), { clamp: '214px' });
  });
}
